import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import Return from '../../ReturnInvoice';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
import { Tooltip, Box } from "@mui/material";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function FullScreenDialog() {
  const [open, setOpen] = React.useState(false);
  const [token, setToken] = useState(() => localStorage.getItem('token') || null);
  const [userSubscription, setUserSubscription] = useState(null);
  const [expireuserSubscription, setExpireUserSubscription] = useState(null);
  const [emptyUserSubscription, setEmptyUserSubscription] = useState(null);
  const [user, setUser] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        navigate("/");
        return;
      }

      try {
        const response = await axios.get("https://admin.bizstor.lk/public/api/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setUser(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          localStorage.removeItem("token");
          navigate("/");
        }
      }
    };

    fetchProfile();
  }, []);


  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

        const matchedSub = response.data.subscription
          .filter(sub => sub.email === user.email && sub.status === "active")
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

        setUserSubscription(matchedSub || null);
      } catch (error) {
        console.error("Failed to fetch subscriptions", error);
      }
    };

    if (user.email) {
      fetchSubscriptions();
    }
  }, [user.email]);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

        const matchedSub = response.data.subscription
          .filter(sub => sub.email === user.email && sub.status === "expire")
          .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0];

        setExpireUserSubscription(matchedSub || null);
      } catch (error) {
        console.error("Failed to fetch subscriptions", error);
      }
    };

    if (user.email) {
      fetchSubscriptions();
    }
  }, [user.email]);

  useEffect(() => {
    const fetchSubscriptions = async () => {
      try {
        const response = await axios.get("https://admin.bizstor.lk/public/api/get-subscription");

        const matchedSub = response.data.subscription
          .filter(sub => sub.email === user.email)[0]; // get first match

        setEmptyUserSubscription(matchedSub || null); // null if no match
      } catch (error) {
        console.error("Failed to fetch subscriptions", error);
        setEmptyUserSubscription(null); // set null on error too
      }
    };

    if (user.email) {
      fetchSubscriptions();
    }
  }, [user.email]);

  const isFreePlan = userSubscription?.plan === "free";
  const isBasicPlan = userSubscription?.plan === "basic";
  const isPremiumPlan = userSubscription?.plan === "premium";
  const expire = expireuserSubscription?.plan === "free" || expireuserSubscription?.plan === "basic" || expireuserSubscription?.plan === "premium" || expireuserSubscription?.plan === "30 days free";


  return (
    <React.Fragment>
      <Tooltip title="Create New Return" arrow>
        <Button
          onClick={handleClickOpen}
          //disabled={!emptyUserSubscription || isFreePlan || isBasicPlan || expire}
          variant="contained"
          startIcon={<AddIcon />}
          sx={{
            width: '170px',
            backgroundColor: '#1976d2',
            borderRadius: '8px',
            textTransform: 'capitalize',
            '&:hover': {
              backgroundColor: '#1565c0',
            },
            mr: 1
          }}
        >
          <Typography variant="caption" sx={{ color: 'white', fontWeight: 'bold', fontSize: 11 }}>
            Create Return
          </Typography>
        </Button>
      </Tooltip>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'fixed', bgcolor: '#FAFAFA',boxShadow:'none' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon sx={{color:'red'}} />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1,color:'black',fontWeight:'bold' }} variant="h6" component="div">
              Return
            </Typography>
          </Toolbar>
        </AppBar>
        <Return />
      </Dialog>
    </React.Fragment>
  );
}
